<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble"><div class="pre" id="pre-005"><span epub:type="pagebreak" id="page_XI" role="doc-pagebreak" title="XI"><h1 class="pre_tit" epub:type="title"><span><a class="renvlnk" id="renv_XI">ACKNOWLEDGMENTS</a></span></h1><div class="dev"><p class="txt_courant_ssalinea"><a class="renvlnk" id="renv_XI">There are many people to thank for their support and contributions to this volume, which has been several years in the making. Boston University School of Theology students James Dooley, Kourtni Brown, Jin Ri (Sam) Kim, John Parker, and Samuel Dubbelman helped gather materials for the volume. Sean Smith, of the Boston University School of Theology Library, helped provide access to texts. I am deeply grateful for the help and encouragement of the Reformation Commentary on Scripture team at IVP Academic, including David McNutt, Scott Prather, and David Hooper, whose collective work greatly improved the volume. Finally, thanks are also due to my family, whose devotion and patience were exercised and tested by the constant presence of Reformation-era commentary on John in their midst, especially during the 2020 pandemic year.</a></p></div></span></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre2.vue?6a90e0e1